<template>
    <section class="smart-review">
        <h2 class="title _title">Отзывы наши клиентов</h2>

        <VueSlickCarousel
            v-if="review && review.length"
            v-bind="sliderOptions"
            class="smart-review__block"
        >
            <div
                v-for="(item, key) in review"
                :key="key"
                class="smart-review__item"
            >
                <div class="smart-review__content">
                    <img
                        class="_img"
                        src="/assets/img/automatize/icons/quotes.svg"
                        alt=""
                    />
                    <h3 class="_review">
                        {{ item.title }}
                    </h3>
                    <p class="_review_text">
                        {{ item.content }}
                    </p>
                </div>
                <div class="smart-review__img">
                    <div class="_img">
                        <img :src="item.media.src" alt="Изображение" />
                    </div>
                    <h4 class="_name">{{ item.name }}</h4>
                    <span class="_city">{{ item.city }}</span>
                </div>
            </div>
        </VueSlickCarousel>
    </section>
</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel';
// import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";

export default {
    name: 'SmartHomeReview',
    components: {
        VueSlickCarousel,
    },
    data() {
        return {
            sliderOptions: {
                infinite: true,
                dots: false,
                arrows: false,
                speed: 300,
                centerMode: true,
                slidesToShow: 1,
                variableWidth: true,
                responsive: [
                    {
                        breakpoint: 992,
                        settings: {
                            variableWidth: false,
                            centerMode: false,
                            slidesToShow: 1,
                        },
                    },
                ],
            },
            review: null,
        };
    },
    mounted() {
        this.getReviews().then((review) => {
            this.review = review;
        });
    },
    methods: {
        async getReviews() {
            try {
                const response = await this.$http.get('/api/reviews');

                const { body } = response;

                const { reviews } = body.data;

                return reviews;
            } catch (error) {
                console.error('getReviews', error);

                return [];
            }
        },
    },
};
</script>
